import React, { Component, Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';
import remove from 'lodash.remove';
import cloneDeep from 'lodash.clonedeep';
import classNames from 'classnames';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from '../dialogs/CustomDialog';
import FormattedPrice from '../../misc/FormattedPrice';

import { FOTO_FLAT, SINGLE_PHOTO, PHOTO_DVD } from '../../../utils/variables';
import { trackEvent } from '../../../utils/ga-tracking';

class Pricelist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showVoucherDialog: false,
    };

    this.handleCloseVoucherDialog = this.handleCloseVoucherDialog.bind(this);
  }

  handleCloseVoucherDialog() {
    this.setState({ showVoucherDialog: false });
  }

  _shouldCenterOfffer(fotoFlat, otherProducts) {
    if (fotoFlat && otherProducts.length === 0) {
      return true;
    }
    if (!fotoFlat && otherProducts.length > 0) {
      return true;
    }
    return false;
  }

  render() {
    const { offer } = this.props;
    const productsClone = cloneDeep(offer.products);
    const fotoFlat = remove(productsClone, p => p.type === FOTO_FLAT)[0];
    // After the FotoFlat has been removed from the list of products, the productsClone
    // list contains all further products (in case only the FotoFlat is offered, the list
    // will be empty).
    const showOtherProducts = productsClone.length > 0;
    const centerOffer = this._shouldCenterOfffer(fotoFlat, productsClone);

    return (
      <Fragment>
        <div className="pricelist-container">
          <div className="row">
            <div className="col-xs-16 col-sm-12 col-sm-offset-2">
              <h1 className="separator">
                <FormattedMessageWrappedInSpan
                  id="pricelist.title"
                  defaultMessage="Offer"
                />
              </h1>
            </div>
          </div>
          <div
            className={classNames('row', {
              'center-sm': centerOffer,
            })}
          >
            {fotoFlat && (
              <div
                className={classNames('col-xs-16', 'col-sm-6', {
                  'col-sm-offset-2': !centerOffer,
                })}
              >
                <div className="pricelist pricelist-primary">
                  <div className="pricelist-header">
                    <FormattedMessageWrappedInSpan
                      id="global.fotoFlat"
                      defaultMessage="Foto-Flat"
                    />
                  </div>
                  <div className="pricelist-body">
                    <div className="pricelist-item">
                      <FormattedMessageWrappedInSpan
                        id="pricelist.personalPhotos"
                        defaultMessage="All personal digital photos (JPG)"
                      />
                    </div>
                    <div className="pricelist-item">
                      <FormattedMessageWrappedInSpan
                        id="pricelist.impressionPhotos"
                        defaultMessage="All impressions (JPG)"
                      />
                    </div>
                    {offer.voucherCampaign && (
                      <div
                        className="pricelist-item pricelist-item-voucher"
                        onClick={() => {
                          this.setState({ showVoucherDialog: true });
                          trackEvent('Event', 'Voucher', 'Offer pricelist');
                        }}
                      >
                        <div
                          className="pricelist-item-voucher-text"
                          dangerouslySetInnerHTML={{
                            __html: offer.voucherCampaign.shortText,
                          }}
                        />
                        <span className="icon eye" />
                      </div>
                    )}
                  </div>
                  <div className="pricelist-main-price">
                    <FormattedPrice price={fotoFlat.price} />
                  </div>
                </div>
              </div>
            )}
            {showOtherProducts && (
              <div className="col-sm-6 col-xs-16">
                <div className="pricelist">
                  <div className="pricelist-header">
                    <FormattedMessageWrappedInSpan
                      id="pricelist.basicOfferTitle"
                      defaultMessage="Basic"
                    />
                  </div>
                  <div className="pricelist-body">
                    {productsClone.map(p => {
                      if (p.type === SINGLE_PHOTO && !p.mediaCollection) {
                        return (
                          <div key={p.id} className="pricelist-item">
                            <FormattedMessageWrappedInSpan
                              id="pricelist.singlePhoto"
                              defaultMessage="1 personal digital photo (JPG)"
                            />
                            <span>
                              <FormattedPrice price={p.price} />
                            </span>
                          </div>
                        );
                      }
                      if (p.type === PHOTO_DVD) {
                        return (
                          <div key={p.id} className="pricelist-item">
                            <FormattedMessageWrappedInSpan
                              id="pricelist.additionalShipment"
                              defaultMessage="Optional: shipping of your order on DVD"
                            />
                            <span>
                              <FormattedPrice price={p.price} />
                            </span>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {offer.voucherCampaign && (
          <CustomDialog
            hasFixedWidth={false}
            open={this.state.showVoucherDialog}
            onRequestClose={this.handleCloseVoucherDialog}
          >
            <div className="notification-container">
              <DialogContent>
                <div className="notification-body">
                  <div
                    dangerouslySetInnerHTML={{ __html: offer.voucherCampaign.longText }}
                  />
                  <div className="voucher-dialog-image">
                    <a
                      href={offer.voucherCampaign.url}
                      onClick={() => trackEvent('Event', 'Voucher', 'Banner dialog')}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={offer.voucherCampaign.banner} />
                    </a>
                  </div>
                </div>
              </DialogContent>
              <DialogActions>
                <div className="notification-action">
                  <button className="accept" onClick={this.handleCloseVoucherDialog}>
                    <FormattedMessageWrappedInSpan
                      id="pricelist.voucherDialog.acceptButton"
                      defaultMessage="Ok"
                    />
                  </button>
                </div>
              </DialogActions>
            </div>
          </CustomDialog>
        )}
      </Fragment>
    );
  }
}

Pricelist.propTypes = {
  offer: PropTypes.object,
};

export { Pricelist };

export default createFragmentContainer(Pricelist, {
  offer: graphql`
    fragment Pricelist_offer on Event {
      products {
        id
        mediaCollection {
          name
        }
        price
        type
      }
      voucherCampaign {
        id
        banner
        longText
        name
        shortText
        url
      }
    }
  `,
});
